import i18n from "../i18n";

export function globalErrorText(error) {
  if (!error.code && error.message) {
    return `${i18n.global.t("errorUnknown")} (${error.message})`;
  } else if (!error.code) {
    return i18n.global.t("errorUnknown");
  }

  switch (error.code) {
    case "auth/wrong-password":
      return i18n.global.t("errorWrongPassword");

    case "auth/email-already-in-use":
      return i18n.global.t("errorEmailAlreadyInUse");

    case "auth/user-not-found":
      return i18n.global.t("errorUserNotFound");

    case "auth/too-many-requests":
      return i18n.global.t("errorTooManyRequests");

    case "functions/invalid-argument":
      return i18n.global.t("errorInvalidArgument");

    default:
      return `${i18n.global.t("errorUnknown")} (Fehlercode: ${error.code})`;
  }
}
